import { DialogActions, DialogContent } from '@mui/material';
import { useState } from 'react';
import BaseDialog from '../../../common/BaseDialog/BaseDialog';
import { InfoIcon } from '../../../../lib/icons/InfoIcon';
import styles from './WaiverDialog.module.scss';
import Button from '../../../common/Button/Button';
import Checkbox from '../../../common/Checkbox/Checkbox';
import { Label } from '../../../common/Label/Label';
import { COMMON_LABELS, DOWNLOADS_LIST_LABELS } from '../../../../lib/constants/labelKeys';
import { DownloadsListProps } from '../../compound/DownloadsList/DownloadsList.types';
import PureRichText from '../../../common/PureRichText/PureRichText';
import BaseDialogHeading from '../../../common/BaseDialog/BaseDialogHeading';
import { downloadsListIds } from '../../../../lib/tests/testIds';

export type WaiverDialogProps = {
  onConfirm: () => void;
  onReject: () => void;
} & Pick<DownloadsListProps, 'waiverContent'>;

const WaiverDialog = ({ onConfirm, onReject, waiverContent }: WaiverDialogProps) => {
  const [selected, setSelected] = useState(false);

  return (
    <BaseDialog classes={{ paper: styles.dialog }} onClose={onReject} data-testid={downloadsListIds.waiverDialog} open>
      <BaseDialogHeading
        titleProps={{ className: styles.title }}
        className={styles.titleRow}
        closeButtonProps={{ className: styles.closeIcon, onClick: onReject }}
      >
        <InfoIcon />
        {waiverContent?.heading}
      </BaseDialogHeading>
      {!!waiverContent?.content && (
        <DialogContent className={styles.waiverContent}>
          <PureRichText richtext={waiverContent.content} />
        </DialogContent>
      )}
      <DialogActions className={styles.actions}>
        <Checkbox
          label={<Label name={DOWNLOADS_LIST_LABELS.waiver.agree} />}
          selected={selected}
          onSelect={setSelected}
          className={styles.agreeCheckbox}
          customClasses={{ label: styles.checkboxLabel }}
        />
        <div className={styles.actionButtons}>
          <Button onClick={onReject} variant="outlined" className={styles.actionButton}>
            <Label name={COMMON_LABELS.DIALOG.CANCEL} />
          </Button>
          <Button onClick={onConfirm} variant="contained" disabled={!selected} className={styles.actionButton}>
            <Label name={DOWNLOADS_LIST_LABELS.waiver.confirm} />
          </Button>
        </div>
      </DialogActions>
    </BaseDialog>
  );
};

export default WaiverDialog;
